import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiResultDispatcherService} from "../../shared/services/api/api-result-dispatcher.service";
import {ApiService} from "../../shared/services/api/api-service";
import {LotNumberParamsModel} from "../models/cofa-widget/lot-number-params.model";
import {LotNumberRequestModel} from "../models/cofa-widget/lot-number-request.model";
import {LotNumberResultItemModel} from "../models/cofa-widget/lot-number-result-item.model";

@Injectable({
    providedIn: "root"
})
export class LotNumberService {
    private API_BASE_URL = "/nop/widgetCofA";

    private API_GET_SEARCH_RESULT_URL = `${this.API_BASE_URL}/searchCofA`;
    private API_SUBMIT_REQUEST_URL = `${this.API_BASE_URL}/submitRequestCofA`;

    public constructor(
        private apiService: ApiService,
        private apiDispatcherService: ApiResultDispatcherService
    ) {
    }

    public getSearchResult(params: LotNumberParamsModel): Observable<LotNumberResultItemModel> {
        const http = this.apiService.executeGet<LotNumberResultItemModel>(
            this.API_GET_SEARCH_RESULT_URL, params
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }

    public requestLotNumber(request: LotNumberRequestModel): Observable<any> {
        const http = this.apiService.executePost<any>(
            this.API_SUBMIT_REQUEST_URL, request
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }
}
